import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=7512cbd2&scoped=true"
import script from "./menu-group.vue?vue&type=script&lang=js"
export * from "./menu-group.vue?vue&type=script&lang=js"
import style0 from "./menu-group.vue?vue&type=style&index=0&id=7512cbd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512cbd2",
  null
  
)

export default component.exports